import { Declined } from "./declined";

export default Declined;